const KEY = "dnc.preferences.v2";

const DEFAULTS = {
  duration_minutes: 10,        // only supported length now (10-min capsules)
  mode: "audio",               // "text" | "audio" (audio is default)
  language: "en",              // "en" | "hi"
  include_global: true,        // Global ON by default
  include_local: false,        // Local OFF by default (country-level when on)
  include_tech: false,         // Technology OFF by default
  tech_topics: [],
  interests: [],               // Personal free-form topics of interest
  location: null,
  lastCapsuleId: null,
  notify_enabled: false,       // daily reminder off by default
  notify_time: "08:00",        // 24h HH:MM local time, default 8 AM
  ready_chime_enabled: true,   // play a soft chime when capsule is ready
};

export function loadPrefs() {
  try {
    const raw = localStorage.getItem(KEY);
    const legacy = raw ? JSON.parse(raw) : {};
    const merged = { ...DEFAULTS, ...legacy };
    // Migrate old preferences from v1/v2
    merged.duration_minutes = 10;                  // force 10 (only option now)
    if (!["text", "audio"].includes(merged.mode)) merged.mode = "audio";
    if (!["en", "hi"].includes(merged.language)) merged.language = "en";
    if (typeof merged.notify_enabled !== "boolean") merged.notify_enabled = false;
    if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(merged.notify_time || "")) merged.notify_time = "08:00";
    if (typeof merged.ready_chime_enabled !== "boolean") merged.ready_chime_enabled = true;
    if (!Array.isArray(merged.interests)) merged.interests = [];
    return merged;
  } catch {
    return { ...DEFAULTS };
  }
}

export function savePrefs(prefs) {
  localStorage.setItem(KEY, JSON.stringify(prefs));
}
